import { useContext } from "react";

import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import { PrescricaoContext } from "../contexts/PrescricaoContext";

import MaskService from "../../../../utils/mask/maskService";

import { findCliente } from "../../../../repositories/qerpapi/erp/prouser/v1/ClienteRepository";

export default function usePrescricaoController() {
  const { setMainClient, setExpanded, setHistory, setDependents, setLoading } =
    useContext(PrescricaoContext);
  const { queryParams } = useContext(QueryParamsContext);

  const handleSelectClient = async (selectedClient) => {
    try {
      setLoading((loading) => ({ ...loading, tables: true }));

      if (selectedClient) {
        const clientCallback = await findCliente({
          empresa_cnpj: queryParams.empresa_cnpj,
          id: selectedClient.id,
          include: `prescricoes${
            queryParams.colaborador === "S" ? ",dependentes" : ""
          }`,
          fields: "[prouser.clientes]=id",
        });
        console.log("retorno :", clientCallback);
        setMainClient(selectedClient);
        setHistory(clientCallback.data?.prescricoes ?? []);
        setDependents(clientCallback.data?.dependentes ?? []);
      } else {
        clearListData();
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading((loading) => ({ ...loading, tables: false }));
    }
  };

  const handleSelectClientModal = (
    setModalClientOpen = () => {},
    selectedClient
  ) => {
    handleSelectClient(selectedClient[0]);
    setModalClientOpen(false);
  };

  const handleChangeOpenAcordion = (accordion) => {
    setExpanded((current) => ({
      ...current,
      [accordion]: !current[accordion],
    }));
  };

  const clientGetOptionLabel = (option) => {
    return `${option.razao} ${
      option.cpfcnpj
        ? `(${MaskService.toMask(
            option.cpfcnpj.replace(/[^0-9]+/g, "").length === 11
              ? "cpf"
              : "cnpj",
            option.cpfcnpj
          )})`
        : ""
    }`;
  };

  const clearListData = () => {
    setMainClient(null);
    setHistory([]);
    setDependents([]);
  };

  const handleAdd = () => {};

  return {
    handleSelectClient,
    handleSelectClientModal,
    handleChangeOpenAcordion,
    clientGetOptionLabel,
    clearListData,
    handleAdd,
  };
}
